import FacebookLikePageTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/facebook/triggers/likePage/InstructionsComponent';
import type {FacebookLikePageTriggerStruct} from '@cohort/shared/apps/facebook/triggers/likePage';
import {FacebookLikePageTriggerSpec} from '@cohort/shared/apps/facebook/triggers/likePage';
import FacebookLikePageTriggerActionCtaComponent from '@cohort/wallet/apps/facebook/triggers/likePage/ActionCtaComponent';
import FacebookLikePageTriggerIntegrationDetailsComponent from '@cohort/wallet/apps/facebook/triggers/likePage/DetailsComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const FacebookLikePageTriggerIntegration: TriggerIntegration<FacebookLikePageTriggerStruct> =
  {
    type: 'action',
    spec: FacebookLikePageTriggerSpec,
    actionCtaComponent: FacebookLikePageTriggerActionCtaComponent,
    detailsComponent: FacebookLikePageTriggerIntegrationDetailsComponent,
    instructionsComponent: FacebookLikePageTriggerIntegrationInstructionsComponent,
  };
